<template>
    <el-card class="full-width-card" shadow="always" :body-style="{padding: '0'}" v-loading="loading">
        <ul class="card-ul">
            <li>
                <h4>{{title}}</h4>
            </li>

			<li class="img-part">
                <div class="hall-img-box">
                    <img :src="imgUrl">
                </div>
			</li>

            <li class="info-part">
                <span class="icon-span"><font-awesome-icon icon="fa-solid fa-location-dot" /></span>&nbsp;<span>{{countryname}}</span>
            </li>

            <li class="info-part">
                <span tkey="有效期">{{i18n.tkey("lang_expiration")}}</span> : <span>{{obj.jstartdate}} - {{obj.jenddate}}</span>
            </li>

            <li class="des-part">
                <span tkey="描述">{{i18n.tkey("lang_des")}}</span> : <span>{{desText}}</span>
            </li>

            <li class="operation-box">
                <el-button
                    type="primary"
                    tkey="編輯"
                    @click="clickEditBtn"
                >
                    {{i18n.tkey("lang_edit")}}
                </el-button>

                <el-button
                    type="danger"
                    tkey="刪除"
                    @click="clickDelBtn"
                >
                    {{i18n.tkey("lang_delete")}}
                </el-button>
            </li>
        </ul>
    </el-card>
</template>

<script setup>

import {computed, inject, onBeforeMount, ref, toRef} from "vue";
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faLocationDot } from '@fortawesome/free-solid-svg-icons'
    import {useUserinfo} from "@/stores/userinfo";
    import myUtil from "@/util/util";
    import { getCountryObj } from "@/util/countrycode";

    library.add(faLocationDot)

    const i18n = inject("i18n")

    const props = defineProps(["obj"])
    const emits = defineEmits(["clickEdit", "clickDel"])

    const loading = ref(false)
    const userInfoRef = toRef(useUserinfo())

    const title = computed(() => {
        let name = props.obj.jobtitle

        if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
            name = props.obj.shipmentaddress
        }

        return name
    })

    const desText = computed(() => {
        let name = props.obj.addinfo1

        if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
            name = props.obj.shipmentaddress
        }

        return name
    })

    const countryname = computed(() => {
        let countrycode = props.obj.district1
        let name = ""

        if (myUtil.isNotEmpty(countrycode)){
            const obj = getCountryObj(countrycode)

            name = obj.szh

            if (userInfoRef.value.lang != "zh" && userInfoRef.value.lang != "szh"){
                name = obj.en
            }
        }

        return name
    })
	
	const imgUrl = computed(() => {
		let url = props.obj.addinfo5
		
		return url
	})

    function clickEditBtn(){
        emits("clickEdit", props.obj)
    }

    function clickDelBtn(){
        emits("clickDel", props.obj)
    }

    onBeforeMount(() => {

    })

</script>

<style scoped>
    .full-width-card {
        width: 100%;
    }

    .card-ul {
        list-style: none;
        padding-left: 0;
        text-align: left;
        padding: 10px;
    }

    .operation-box {
        text-align: center;
        margin-top: 15px;
    }

    .info-part {
        line-height: 2;
        color: #606266;
    }

    .des-part {
        height: 4.5em;
        line-height: 1.5;
        overflow: hidden;
        color: #606266;
    }

    .icon-span {
        color: #79bbff;
    }
	
	.additionlrecord14-img{
		width: 100%;
	}
	.img-part .hall-img-box {
	    position: relative;
	    width: 100%;
	    box-sizing: border-box;
	    padding-top: 50%;
	}
	
	.img-part .hall-img-box img {
	    position: absolute;
	    width: 100%;
	    height: 100%;
	    object-fit: fill;
	    top: 0;
	    left: 0;
	    border: 1px #E4E7ED solid;
	}
</style>